import { CALL_API } from '../middleware/api';
import serialize from 'object-to-formdata';
export const FETCH_SERVICES = "FETCH_SERVICES";
export const SUCCESS_FETCH_SERVICES = "SUCCESS_FETCH_SERVICES";
export const FAILURE_FETCH_SERVICES = "FAILURE_FETCH_SERVICES";

export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const SUCCESS_UPDATE_SERVICE = "SUCCESS_UPDATE_SERVICE";
export const FAILURE_UPDATE_SERVICE = "FAILURE_UPDATE_SERVICE";
export const CLEAR_UPDATE_SERVICE = "CLEAR_UPDATE_SERVICE";

export const CREATE_SERVICE = "CREATE_SERVICE";
export const SUCCESS_CREATE_SERVICE = "SUCCESS_CREATE_SERVICE";
export const FAILURE_CREATE_SERVICE = "FAILURE_CREATE_SERVICE";
export const CLEAR_CREATE_SERVICE = "CLEAR_CREATE_SERVICE";

export function fetchServices(filterData) {
    const query = createQuery(filterData);
    return {
        type: FETCH_SERVICES,
        [CALL_API]: {
            endpoint: `/api/services?${query}`,
            method: 'get',
            types: [SUCCESS_FETCH_SERVICES, FAILURE_FETCH_SERVICES]
        }
    }
}

export function updateService(data) {
    const { Id } = data;
    return {
        type: UPDATE_SERVICE,
        [CALL_API]: {
            endpoint: `/api/services/${Id}`,
            method: 'post',
            types: [SUCCESS_UPDATE_SERVICE, FAILURE_UPDATE_SERVICE],
            data: serialize(data),
            isFormData: true
        }
    }
}

export function createService(data) {
    return {
        type: CREATE_SERVICE,
        [CALL_API]: {
            endpoint: `/api/services/`,
            method: 'post',
            types: [SUCCESS_CREATE_SERVICE, FAILURE_CREATE_SERVICE],            
            data: serialize(data),
            isFormData: true
        }
    }
}

export function clearUpdateService() {
    return { type: CLEAR_UPDATE_SERVICE }
}

export function clearCreateService() {
    return { type: CLEAR_CREATE_SERVICE }
}

const createQuery = ({ category, isActive }) => {
    if (!category && !isActive)
        return '';
    let categoryQuery = category.Id !== 0 ? `categoryId=${category.Id}` : '';
    const isActiveQuery = isActive.Value !== null ? `isActive=${isActive.Value}` : '';

    const query = `${categoryQuery}${categoryQuery && isActiveQuery ? '&' : ''}${isActiveQuery}`;
    return query;
}


// WEBPACK FOOTER //
// ./src/actions/services.js